module.exports = __webpack_public_path__ + "img/kz_pic3.4ec4fe7e.png";